import { loadRestJsonErrorCode, parseJsonBody as parseBody, parseJsonErrorBody as parseErrorBody } from "@aws-sdk/core";
import { HttpRequest as __HttpRequest } from "@smithy/protocol-http";
import { _json, collectBody, decorateServiceException as __decorateServiceException, expectBoolean as __expectBoolean, expectNonNull as __expectNonNull, expectNumber as __expectNumber, expectString as __expectString, parseEpochTimestamp as __parseEpochTimestamp, take, withBaseException, } from "@smithy/smithy-client";
import { ConfigServiceServiceException as __BaseException } from "../models/ConfigServiceServiceException";
import { ConformancePackTemplateValidationException, IdempotentParameterMismatch, InsufficientDeliveryPolicyException, InsufficientPermissionsException, InvalidConfigurationRecorderNameException, InvalidDeliveryChannelNameException, InvalidExpressionException, InvalidLimitException, InvalidNextTokenException, InvalidParameterValueException, InvalidRecordingGroupException, InvalidResultTokenException, InvalidRoleException, InvalidS3KeyPrefixException, InvalidS3KmsKeyArnException, InvalidSNSTopicARNException, InvalidTimeRangeException, LastDeliveryChannelDeleteFailedException, LimitExceededException, NoAvailableConfigurationRecorderException, NoRunningConfigurationRecorderException, NoSuchConfigRuleException, NoSuchConfigRuleInConformancePackException, NoSuchConfigurationAggregatorException, NoSuchConfigurationRecorderException, NoSuchConformancePackException, NoSuchDeliveryChannelException, NoSuchOrganizationConfigRuleException, NoSuchOrganizationConformancePackException, NoSuchRemediationConfigurationException, NoSuchRemediationExceptionException, NoSuchRetentionConfigurationException, OrganizationAccessDeniedException, OversizedConfigurationItemException, RemediationInProgressException, ResourceInUseException, ResourceNotDiscoveredException, ResourceNotFoundException, ValidationException, } from "../models/models_0";
import { MaxActiveResourcesExceededException, MaxNumberOfConfigRulesExceededException, MaxNumberOfConfigurationRecordersExceededException, MaxNumberOfConformancePacksExceededException, MaxNumberOfDeliveryChannelsExceededException, MaxNumberOfOrganizationConfigRulesExceededException, MaxNumberOfOrganizationConformancePacksExceededException, MaxNumberOfRetentionConfigurationsExceededException, NoAvailableDeliveryChannelException, NoAvailableOrganizationException, NoSuchBucketException, OrganizationAllFeaturesNotEnabledException, OrganizationConformancePackTemplateValidationException, ResourceConcurrentModificationException, TooManyTagsException, } from "../models/models_1";
export const se_BatchGetAggregateResourceConfigCommand = async (input, context) => {
    const headers = sharedHeaders("BatchGetAggregateResourceConfig");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_BatchGetResourceConfigCommand = async (input, context) => {
    const headers = sharedHeaders("BatchGetResourceConfig");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeleteAggregationAuthorizationCommand = async (input, context) => {
    const headers = sharedHeaders("DeleteAggregationAuthorization");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeleteConfigRuleCommand = async (input, context) => {
    const headers = sharedHeaders("DeleteConfigRule");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeleteConfigurationAggregatorCommand = async (input, context) => {
    const headers = sharedHeaders("DeleteConfigurationAggregator");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeleteConfigurationRecorderCommand = async (input, context) => {
    const headers = sharedHeaders("DeleteConfigurationRecorder");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeleteConformancePackCommand = async (input, context) => {
    const headers = sharedHeaders("DeleteConformancePack");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeleteDeliveryChannelCommand = async (input, context) => {
    const headers = sharedHeaders("DeleteDeliveryChannel");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeleteEvaluationResultsCommand = async (input, context) => {
    const headers = sharedHeaders("DeleteEvaluationResults");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeleteOrganizationConfigRuleCommand = async (input, context) => {
    const headers = sharedHeaders("DeleteOrganizationConfigRule");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeleteOrganizationConformancePackCommand = async (input, context) => {
    const headers = sharedHeaders("DeleteOrganizationConformancePack");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeletePendingAggregationRequestCommand = async (input, context) => {
    const headers = sharedHeaders("DeletePendingAggregationRequest");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeleteRemediationConfigurationCommand = async (input, context) => {
    const headers = sharedHeaders("DeleteRemediationConfiguration");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeleteRemediationExceptionsCommand = async (input, context) => {
    const headers = sharedHeaders("DeleteRemediationExceptions");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeleteResourceConfigCommand = async (input, context) => {
    const headers = sharedHeaders("DeleteResourceConfig");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeleteRetentionConfigurationCommand = async (input, context) => {
    const headers = sharedHeaders("DeleteRetentionConfiguration");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeleteStoredQueryCommand = async (input, context) => {
    const headers = sharedHeaders("DeleteStoredQuery");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DeliverConfigSnapshotCommand = async (input, context) => {
    const headers = sharedHeaders("DeliverConfigSnapshot");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeAggregateComplianceByConfigRulesCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeAggregateComplianceByConfigRules");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeAggregateComplianceByConformancePacksCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeAggregateComplianceByConformancePacks");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeAggregationAuthorizationsCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeAggregationAuthorizations");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeComplianceByConfigRuleCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeComplianceByConfigRule");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeComplianceByResourceCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeComplianceByResource");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeConfigRuleEvaluationStatusCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeConfigRuleEvaluationStatus");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeConfigRulesCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeConfigRules");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeConfigurationAggregatorsCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeConfigurationAggregators");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeConfigurationAggregatorSourcesStatusCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeConfigurationAggregatorSourcesStatus");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeConfigurationRecordersCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeConfigurationRecorders");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeConfigurationRecorderStatusCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeConfigurationRecorderStatus");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeConformancePackComplianceCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeConformancePackCompliance");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeConformancePacksCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeConformancePacks");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeConformancePackStatusCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeConformancePackStatus");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeDeliveryChannelsCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeDeliveryChannels");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeDeliveryChannelStatusCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeDeliveryChannelStatus");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeOrganizationConfigRulesCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeOrganizationConfigRules");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeOrganizationConfigRuleStatusesCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeOrganizationConfigRuleStatuses");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeOrganizationConformancePacksCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeOrganizationConformancePacks");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeOrganizationConformancePackStatusesCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeOrganizationConformancePackStatuses");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribePendingAggregationRequestsCommand = async (input, context) => {
    const headers = sharedHeaders("DescribePendingAggregationRequests");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeRemediationConfigurationsCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeRemediationConfigurations");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeRemediationExceptionsCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeRemediationExceptions");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeRemediationExecutionStatusCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeRemediationExecutionStatus");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_DescribeRetentionConfigurationsCommand = async (input, context) => {
    const headers = sharedHeaders("DescribeRetentionConfigurations");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetAggregateComplianceDetailsByConfigRuleCommand = async (input, context) => {
    const headers = sharedHeaders("GetAggregateComplianceDetailsByConfigRule");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetAggregateConfigRuleComplianceSummaryCommand = async (input, context) => {
    const headers = sharedHeaders("GetAggregateConfigRuleComplianceSummary");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetAggregateConformancePackComplianceSummaryCommand = async (input, context) => {
    const headers = sharedHeaders("GetAggregateConformancePackComplianceSummary");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetAggregateDiscoveredResourceCountsCommand = async (input, context) => {
    const headers = sharedHeaders("GetAggregateDiscoveredResourceCounts");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetAggregateResourceConfigCommand = async (input, context) => {
    const headers = sharedHeaders("GetAggregateResourceConfig");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetComplianceDetailsByConfigRuleCommand = async (input, context) => {
    const headers = sharedHeaders("GetComplianceDetailsByConfigRule");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetComplianceDetailsByResourceCommand = async (input, context) => {
    const headers = sharedHeaders("GetComplianceDetailsByResource");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetComplianceSummaryByConfigRuleCommand = async (input, context) => {
    const headers = sharedHeaders("GetComplianceSummaryByConfigRule");
    const body = "{}";
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetComplianceSummaryByResourceTypeCommand = async (input, context) => {
    const headers = sharedHeaders("GetComplianceSummaryByResourceType");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetConformancePackComplianceDetailsCommand = async (input, context) => {
    const headers = sharedHeaders("GetConformancePackComplianceDetails");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetConformancePackComplianceSummaryCommand = async (input, context) => {
    const headers = sharedHeaders("GetConformancePackComplianceSummary");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetCustomRulePolicyCommand = async (input, context) => {
    const headers = sharedHeaders("GetCustomRulePolicy");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetDiscoveredResourceCountsCommand = async (input, context) => {
    const headers = sharedHeaders("GetDiscoveredResourceCounts");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetOrganizationConfigRuleDetailedStatusCommand = async (input, context) => {
    const headers = sharedHeaders("GetOrganizationConfigRuleDetailedStatus");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetOrganizationConformancePackDetailedStatusCommand = async (input, context) => {
    const headers = sharedHeaders("GetOrganizationConformancePackDetailedStatus");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetOrganizationCustomRulePolicyCommand = async (input, context) => {
    const headers = sharedHeaders("GetOrganizationCustomRulePolicy");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetResourceConfigHistoryCommand = async (input, context) => {
    const headers = sharedHeaders("GetResourceConfigHistory");
    let body;
    body = JSON.stringify(se_GetResourceConfigHistoryRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetResourceEvaluationSummaryCommand = async (input, context) => {
    const headers = sharedHeaders("GetResourceEvaluationSummary");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_GetStoredQueryCommand = async (input, context) => {
    const headers = sharedHeaders("GetStoredQuery");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_ListAggregateDiscoveredResourcesCommand = async (input, context) => {
    const headers = sharedHeaders("ListAggregateDiscoveredResources");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_ListConformancePackComplianceScoresCommand = async (input, context) => {
    const headers = sharedHeaders("ListConformancePackComplianceScores");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_ListDiscoveredResourcesCommand = async (input, context) => {
    const headers = sharedHeaders("ListDiscoveredResources");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_ListResourceEvaluationsCommand = async (input, context) => {
    const headers = sharedHeaders("ListResourceEvaluations");
    let body;
    body = JSON.stringify(se_ListResourceEvaluationsRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_ListStoredQueriesCommand = async (input, context) => {
    const headers = sharedHeaders("ListStoredQueries");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_ListTagsForResourceCommand = async (input, context) => {
    const headers = sharedHeaders("ListTagsForResource");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_PutAggregationAuthorizationCommand = async (input, context) => {
    const headers = sharedHeaders("PutAggregationAuthorization");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_PutConfigRuleCommand = async (input, context) => {
    const headers = sharedHeaders("PutConfigRule");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_PutConfigurationAggregatorCommand = async (input, context) => {
    const headers = sharedHeaders("PutConfigurationAggregator");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_PutConfigurationRecorderCommand = async (input, context) => {
    const headers = sharedHeaders("PutConfigurationRecorder");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_PutConformancePackCommand = async (input, context) => {
    const headers = sharedHeaders("PutConformancePack");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_PutDeliveryChannelCommand = async (input, context) => {
    const headers = sharedHeaders("PutDeliveryChannel");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_PutEvaluationsCommand = async (input, context) => {
    const headers = sharedHeaders("PutEvaluations");
    let body;
    body = JSON.stringify(se_PutEvaluationsRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_PutExternalEvaluationCommand = async (input, context) => {
    const headers = sharedHeaders("PutExternalEvaluation");
    let body;
    body = JSON.stringify(se_PutExternalEvaluationRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_PutOrganizationConfigRuleCommand = async (input, context) => {
    const headers = sharedHeaders("PutOrganizationConfigRule");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_PutOrganizationConformancePackCommand = async (input, context) => {
    const headers = sharedHeaders("PutOrganizationConformancePack");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_PutRemediationConfigurationsCommand = async (input, context) => {
    const headers = sharedHeaders("PutRemediationConfigurations");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_PutRemediationExceptionsCommand = async (input, context) => {
    const headers = sharedHeaders("PutRemediationExceptions");
    let body;
    body = JSON.stringify(se_PutRemediationExceptionsRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_PutResourceConfigCommand = async (input, context) => {
    const headers = sharedHeaders("PutResourceConfig");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_PutRetentionConfigurationCommand = async (input, context) => {
    const headers = sharedHeaders("PutRetentionConfiguration");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_PutStoredQueryCommand = async (input, context) => {
    const headers = sharedHeaders("PutStoredQuery");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_SelectAggregateResourceConfigCommand = async (input, context) => {
    const headers = sharedHeaders("SelectAggregateResourceConfig");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_SelectResourceConfigCommand = async (input, context) => {
    const headers = sharedHeaders("SelectResourceConfig");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_StartConfigRulesEvaluationCommand = async (input, context) => {
    const headers = sharedHeaders("StartConfigRulesEvaluation");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_StartConfigurationRecorderCommand = async (input, context) => {
    const headers = sharedHeaders("StartConfigurationRecorder");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_StartRemediationExecutionCommand = async (input, context) => {
    const headers = sharedHeaders("StartRemediationExecution");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_StartResourceEvaluationCommand = async (input, context) => {
    const headers = sharedHeaders("StartResourceEvaluation");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_StopConfigurationRecorderCommand = async (input, context) => {
    const headers = sharedHeaders("StopConfigurationRecorder");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_TagResourceCommand = async (input, context) => {
    const headers = sharedHeaders("TagResource");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const se_UntagResourceCommand = async (input, context) => {
    const headers = sharedHeaders("UntagResource");
    let body;
    body = JSON.stringify(_json(input));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
export const de_BatchGetAggregateResourceConfigCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_BatchGetAggregateResourceConfigResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_BatchGetResourceConfigCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_BatchGetResourceConfigResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DeleteAggregationAuthorizationCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
export const de_DeleteConfigRuleCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
export const de_DeleteConfigurationAggregatorCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
export const de_DeleteConfigurationRecorderCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
export const de_DeleteConformancePackCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
export const de_DeleteDeliveryChannelCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
export const de_DeleteEvaluationResultsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DeleteOrganizationConfigRuleCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
export const de_DeleteOrganizationConformancePackCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
export const de_DeletePendingAggregationRequestCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
export const de_DeleteRemediationConfigurationCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DeleteRemediationExceptionsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DeleteResourceConfigCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
export const de_DeleteRetentionConfigurationCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
export const de_DeleteStoredQueryCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DeliverConfigSnapshotCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeAggregateComplianceByConfigRulesCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeAggregateComplianceByConformancePacksCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeAggregationAuthorizationsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_DescribeAggregationAuthorizationsResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeComplianceByConfigRuleCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeComplianceByResourceCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeConfigRuleEvaluationStatusCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_DescribeConfigRuleEvaluationStatusResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeConfigRulesCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeConfigurationAggregatorsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_DescribeConfigurationAggregatorsResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeConfigurationAggregatorSourcesStatusCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_DescribeConfigurationAggregatorSourcesStatusResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeConfigurationRecordersCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeConfigurationRecorderStatusCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_DescribeConfigurationRecorderStatusResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeConformancePackComplianceCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeConformancePacksCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_DescribeConformancePacksResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeConformancePackStatusCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_DescribeConformancePackStatusResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeDeliveryChannelsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeDeliveryChannelStatusCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_DescribeDeliveryChannelStatusResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeOrganizationConfigRulesCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_DescribeOrganizationConfigRulesResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeOrganizationConfigRuleStatusesCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_DescribeOrganizationConfigRuleStatusesResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeOrganizationConformancePacksCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_DescribeOrganizationConformancePacksResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeOrganizationConformancePackStatusesCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_DescribeOrganizationConformancePackStatusesResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribePendingAggregationRequestsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeRemediationConfigurationsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeRemediationExceptionsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_DescribeRemediationExceptionsResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeRemediationExecutionStatusCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_DescribeRemediationExecutionStatusResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_DescribeRetentionConfigurationsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetAggregateComplianceDetailsByConfigRuleCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_GetAggregateComplianceDetailsByConfigRuleResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetAggregateConfigRuleComplianceSummaryCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_GetAggregateConfigRuleComplianceSummaryResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetAggregateConformancePackComplianceSummaryCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetAggregateDiscoveredResourceCountsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetAggregateResourceConfigCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_GetAggregateResourceConfigResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetComplianceDetailsByConfigRuleCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_GetComplianceDetailsByConfigRuleResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetComplianceDetailsByResourceCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_GetComplianceDetailsByResourceResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetComplianceSummaryByConfigRuleCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_GetComplianceSummaryByConfigRuleResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetComplianceSummaryByResourceTypeCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_GetComplianceSummaryByResourceTypeResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetConformancePackComplianceDetailsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_GetConformancePackComplianceDetailsResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetConformancePackComplianceSummaryCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetCustomRulePolicyCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetDiscoveredResourceCountsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetOrganizationConfigRuleDetailedStatusCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_GetOrganizationConfigRuleDetailedStatusResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetOrganizationConformancePackDetailedStatusCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_GetOrganizationConformancePackDetailedStatusResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetOrganizationCustomRulePolicyCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetResourceConfigHistoryCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_GetResourceConfigHistoryResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetResourceEvaluationSummaryCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_GetResourceEvaluationSummaryResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_GetStoredQueryCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_ListAggregateDiscoveredResourcesCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_ListConformancePackComplianceScoresCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_ListConformancePackComplianceScoresResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_ListDiscoveredResourcesCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_ListDiscoveredResourcesResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_ListResourceEvaluationsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_ListResourceEvaluationsResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_ListStoredQueriesCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_ListTagsForResourceCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_PutAggregationAuthorizationCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_PutAggregationAuthorizationResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_PutConfigRuleCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
export const de_PutConfigurationAggregatorCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_PutConfigurationAggregatorResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_PutConfigurationRecorderCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
export const de_PutConformancePackCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_PutDeliveryChannelCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
export const de_PutEvaluationsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_PutEvaluationsResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_PutExternalEvaluationCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_PutOrganizationConfigRuleCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_PutOrganizationConformancePackCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_PutRemediationConfigurationsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_PutRemediationExceptionsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = de_PutRemediationExceptionsResponse(data, context);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_PutResourceConfigCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
export const de_PutRetentionConfigurationCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_PutStoredQueryCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_SelectAggregateResourceConfigCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_SelectResourceConfigCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_StartConfigRulesEvaluationCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_StartConfigurationRecorderCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
export const de_StartRemediationExecutionCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_StartResourceEvaluationCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = _json(data);
    const response = {
        $metadata: deserializeMetadata(output),
        ...contents,
    };
    return response;
};
export const de_StopConfigurationRecorderCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
export const de_TagResourceCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
export const de_UntagResourceCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: deserializeMetadata(output),
    };
    return response;
};
const de_CommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "NoSuchConfigurationAggregatorException":
        case "com.amazonaws.configservice#NoSuchConfigurationAggregatorException":
            throw await de_NoSuchConfigurationAggregatorExceptionRes(parsedOutput, context);
        case "ValidationException":
        case "com.amazonaws.configservice#ValidationException":
            throw await de_ValidationExceptionRes(parsedOutput, context);
        case "NoAvailableConfigurationRecorderException":
        case "com.amazonaws.configservice#NoAvailableConfigurationRecorderException":
            throw await de_NoAvailableConfigurationRecorderExceptionRes(parsedOutput, context);
        case "InvalidParameterValueException":
        case "com.amazonaws.configservice#InvalidParameterValueException":
            throw await de_InvalidParameterValueExceptionRes(parsedOutput, context);
        case "NoSuchConfigRuleException":
        case "com.amazonaws.configservice#NoSuchConfigRuleException":
            throw await de_NoSuchConfigRuleExceptionRes(parsedOutput, context);
        case "ResourceInUseException":
        case "com.amazonaws.configservice#ResourceInUseException":
            throw await de_ResourceInUseExceptionRes(parsedOutput, context);
        case "NoSuchConfigurationRecorderException":
        case "com.amazonaws.configservice#NoSuchConfigurationRecorderException":
            throw await de_NoSuchConfigurationRecorderExceptionRes(parsedOutput, context);
        case "NoSuchConformancePackException":
        case "com.amazonaws.configservice#NoSuchConformancePackException":
            throw await de_NoSuchConformancePackExceptionRes(parsedOutput, context);
        case "LastDeliveryChannelDeleteFailedException":
        case "com.amazonaws.configservice#LastDeliveryChannelDeleteFailedException":
            throw await de_LastDeliveryChannelDeleteFailedExceptionRes(parsedOutput, context);
        case "NoSuchDeliveryChannelException":
        case "com.amazonaws.configservice#NoSuchDeliveryChannelException":
            throw await de_NoSuchDeliveryChannelExceptionRes(parsedOutput, context);
        case "NoSuchOrganizationConfigRuleException":
        case "com.amazonaws.configservice#NoSuchOrganizationConfigRuleException":
            throw await de_NoSuchOrganizationConfigRuleExceptionRes(parsedOutput, context);
        case "OrganizationAccessDeniedException":
        case "com.amazonaws.configservice#OrganizationAccessDeniedException":
            throw await de_OrganizationAccessDeniedExceptionRes(parsedOutput, context);
        case "NoSuchOrganizationConformancePackException":
        case "com.amazonaws.configservice#NoSuchOrganizationConformancePackException":
            throw await de_NoSuchOrganizationConformancePackExceptionRes(parsedOutput, context);
        case "InsufficientPermissionsException":
        case "com.amazonaws.configservice#InsufficientPermissionsException":
            throw await de_InsufficientPermissionsExceptionRes(parsedOutput, context);
        case "NoSuchRemediationConfigurationException":
        case "com.amazonaws.configservice#NoSuchRemediationConfigurationException":
            throw await de_NoSuchRemediationConfigurationExceptionRes(parsedOutput, context);
        case "RemediationInProgressException":
        case "com.amazonaws.configservice#RemediationInProgressException":
            throw await de_RemediationInProgressExceptionRes(parsedOutput, context);
        case "NoSuchRemediationExceptionException":
        case "com.amazonaws.configservice#NoSuchRemediationExceptionException":
            throw await de_NoSuchRemediationExceptionExceptionRes(parsedOutput, context);
        case "NoRunningConfigurationRecorderException":
        case "com.amazonaws.configservice#NoRunningConfigurationRecorderException":
            throw await de_NoRunningConfigurationRecorderExceptionRes(parsedOutput, context);
        case "NoSuchRetentionConfigurationException":
        case "com.amazonaws.configservice#NoSuchRetentionConfigurationException":
            throw await de_NoSuchRetentionConfigurationExceptionRes(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.configservice#ResourceNotFoundException":
            throw await de_ResourceNotFoundExceptionRes(parsedOutput, context);
        case "InvalidLimitException":
        case "com.amazonaws.configservice#InvalidLimitException":
            throw await de_InvalidLimitExceptionRes(parsedOutput, context);
        case "InvalidNextTokenException":
        case "com.amazonaws.configservice#InvalidNextTokenException":
            throw await de_InvalidNextTokenExceptionRes(parsedOutput, context);
        case "NoSuchConfigRuleInConformancePackException":
        case "com.amazonaws.configservice#NoSuchConfigRuleInConformancePackException":
            throw await de_NoSuchConfigRuleInConformancePackExceptionRes(parsedOutput, context);
        case "OversizedConfigurationItemException":
        case "com.amazonaws.configservice#OversizedConfigurationItemException":
            throw await de_OversizedConfigurationItemExceptionRes(parsedOutput, context);
        case "ResourceNotDiscoveredException":
        case "com.amazonaws.configservice#ResourceNotDiscoveredException":
            throw await de_ResourceNotDiscoveredExceptionRes(parsedOutput, context);
        case "InvalidTimeRangeException":
        case "com.amazonaws.configservice#InvalidTimeRangeException":
            throw await de_InvalidTimeRangeExceptionRes(parsedOutput, context);
        case "MaxNumberOfConfigRulesExceededException":
        case "com.amazonaws.configservice#MaxNumberOfConfigRulesExceededException":
            throw await de_MaxNumberOfConfigRulesExceededExceptionRes(parsedOutput, context);
        case "InvalidRoleException":
        case "com.amazonaws.configservice#InvalidRoleException":
            throw await de_InvalidRoleExceptionRes(parsedOutput, context);
        case "LimitExceededException":
        case "com.amazonaws.configservice#LimitExceededException":
            throw await de_LimitExceededExceptionRes(parsedOutput, context);
        case "NoAvailableOrganizationException":
        case "com.amazonaws.configservice#NoAvailableOrganizationException":
            throw await de_NoAvailableOrganizationExceptionRes(parsedOutput, context);
        case "OrganizationAllFeaturesNotEnabledException":
        case "com.amazonaws.configservice#OrganizationAllFeaturesNotEnabledException":
            throw await de_OrganizationAllFeaturesNotEnabledExceptionRes(parsedOutput, context);
        case "InvalidConfigurationRecorderNameException":
        case "com.amazonaws.configservice#InvalidConfigurationRecorderNameException":
            throw await de_InvalidConfigurationRecorderNameExceptionRes(parsedOutput, context);
        case "InvalidRecordingGroupException":
        case "com.amazonaws.configservice#InvalidRecordingGroupException":
            throw await de_InvalidRecordingGroupExceptionRes(parsedOutput, context);
        case "MaxNumberOfConfigurationRecordersExceededException":
        case "com.amazonaws.configservice#MaxNumberOfConfigurationRecordersExceededException":
            throw await de_MaxNumberOfConfigurationRecordersExceededExceptionRes(parsedOutput, context);
        case "ConformancePackTemplateValidationException":
        case "com.amazonaws.configservice#ConformancePackTemplateValidationException":
            throw await de_ConformancePackTemplateValidationExceptionRes(parsedOutput, context);
        case "MaxNumberOfConformancePacksExceededException":
        case "com.amazonaws.configservice#MaxNumberOfConformancePacksExceededException":
            throw await de_MaxNumberOfConformancePacksExceededExceptionRes(parsedOutput, context);
        case "InsufficientDeliveryPolicyException":
        case "com.amazonaws.configservice#InsufficientDeliveryPolicyException":
            throw await de_InsufficientDeliveryPolicyExceptionRes(parsedOutput, context);
        case "InvalidDeliveryChannelNameException":
        case "com.amazonaws.configservice#InvalidDeliveryChannelNameException":
            throw await de_InvalidDeliveryChannelNameExceptionRes(parsedOutput, context);
        case "InvalidS3KeyPrefixException":
        case "com.amazonaws.configservice#InvalidS3KeyPrefixException":
            throw await de_InvalidS3KeyPrefixExceptionRes(parsedOutput, context);
        case "InvalidS3KmsKeyArnException":
        case "com.amazonaws.configservice#InvalidS3KmsKeyArnException":
            throw await de_InvalidS3KmsKeyArnExceptionRes(parsedOutput, context);
        case "InvalidSNSTopicARNException":
        case "com.amazonaws.configservice#InvalidSNSTopicARNException":
            throw await de_InvalidSNSTopicARNExceptionRes(parsedOutput, context);
        case "MaxNumberOfDeliveryChannelsExceededException":
        case "com.amazonaws.configservice#MaxNumberOfDeliveryChannelsExceededException":
            throw await de_MaxNumberOfDeliveryChannelsExceededExceptionRes(parsedOutput, context);
        case "NoSuchBucketException":
        case "com.amazonaws.configservice#NoSuchBucketException":
            throw await de_NoSuchBucketExceptionRes(parsedOutput, context);
        case "InvalidResultTokenException":
        case "com.amazonaws.configservice#InvalidResultTokenException":
            throw await de_InvalidResultTokenExceptionRes(parsedOutput, context);
        case "MaxNumberOfOrganizationConfigRulesExceededException":
        case "com.amazonaws.configservice#MaxNumberOfOrganizationConfigRulesExceededException":
            throw await de_MaxNumberOfOrganizationConfigRulesExceededExceptionRes(parsedOutput, context);
        case "MaxNumberOfOrganizationConformancePacksExceededException":
        case "com.amazonaws.configservice#MaxNumberOfOrganizationConformancePacksExceededException":
            throw await de_MaxNumberOfOrganizationConformancePacksExceededExceptionRes(parsedOutput, context);
        case "OrganizationConformancePackTemplateValidationException":
        case "com.amazonaws.configservice#OrganizationConformancePackTemplateValidationException":
            throw await de_OrganizationConformancePackTemplateValidationExceptionRes(parsedOutput, context);
        case "MaxActiveResourcesExceededException":
        case "com.amazonaws.configservice#MaxActiveResourcesExceededException":
            throw await de_MaxActiveResourcesExceededExceptionRes(parsedOutput, context);
        case "MaxNumberOfRetentionConfigurationsExceededException":
        case "com.amazonaws.configservice#MaxNumberOfRetentionConfigurationsExceededException":
            throw await de_MaxNumberOfRetentionConfigurationsExceededExceptionRes(parsedOutput, context);
        case "ResourceConcurrentModificationException":
        case "com.amazonaws.configservice#ResourceConcurrentModificationException":
            throw await de_ResourceConcurrentModificationExceptionRes(parsedOutput, context);
        case "TooManyTagsException":
        case "com.amazonaws.configservice#TooManyTagsException":
            throw await de_TooManyTagsExceptionRes(parsedOutput, context);
        case "InvalidExpressionException":
        case "com.amazonaws.configservice#InvalidExpressionException":
            throw await de_InvalidExpressionExceptionRes(parsedOutput, context);
        case "NoAvailableDeliveryChannelException":
        case "com.amazonaws.configservice#NoAvailableDeliveryChannelException":
            throw await de_NoAvailableDeliveryChannelExceptionRes(parsedOutput, context);
        case "IdempotentParameterMismatch":
        case "com.amazonaws.configservice#IdempotentParameterMismatch":
            throw await de_IdempotentParameterMismatchRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return throwDefaultError({
                output,
                parsedBody,
                errorCode,
            });
    }
};
const de_ConformancePackTemplateValidationExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new ConformancePackTemplateValidationException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_IdempotentParameterMismatchRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new IdempotentParameterMismatch({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_InsufficientDeliveryPolicyExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new InsufficientDeliveryPolicyException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_InsufficientPermissionsExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new InsufficientPermissionsException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_InvalidConfigurationRecorderNameExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new InvalidConfigurationRecorderNameException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_InvalidDeliveryChannelNameExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new InvalidDeliveryChannelNameException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_InvalidExpressionExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new InvalidExpressionException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_InvalidLimitExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new InvalidLimitException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_InvalidNextTokenExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new InvalidNextTokenException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_InvalidParameterValueExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new InvalidParameterValueException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_InvalidRecordingGroupExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new InvalidRecordingGroupException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_InvalidResultTokenExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new InvalidResultTokenException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_InvalidRoleExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new InvalidRoleException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_InvalidS3KeyPrefixExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new InvalidS3KeyPrefixException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_InvalidS3KmsKeyArnExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new InvalidS3KmsKeyArnException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_InvalidSNSTopicARNExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new InvalidSNSTopicARNException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_InvalidTimeRangeExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new InvalidTimeRangeException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_LastDeliveryChannelDeleteFailedExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new LastDeliveryChannelDeleteFailedException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_LimitExceededExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new LimitExceededException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_MaxActiveResourcesExceededExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new MaxActiveResourcesExceededException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_MaxNumberOfConfigRulesExceededExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new MaxNumberOfConfigRulesExceededException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_MaxNumberOfConfigurationRecordersExceededExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new MaxNumberOfConfigurationRecordersExceededException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_MaxNumberOfConformancePacksExceededExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new MaxNumberOfConformancePacksExceededException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_MaxNumberOfDeliveryChannelsExceededExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new MaxNumberOfDeliveryChannelsExceededException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_MaxNumberOfOrganizationConfigRulesExceededExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new MaxNumberOfOrganizationConfigRulesExceededException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_MaxNumberOfOrganizationConformancePacksExceededExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new MaxNumberOfOrganizationConformancePacksExceededException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_MaxNumberOfRetentionConfigurationsExceededExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new MaxNumberOfRetentionConfigurationsExceededException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_NoAvailableConfigurationRecorderExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new NoAvailableConfigurationRecorderException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_NoAvailableDeliveryChannelExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new NoAvailableDeliveryChannelException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_NoAvailableOrganizationExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new NoAvailableOrganizationException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_NoRunningConfigurationRecorderExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new NoRunningConfigurationRecorderException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_NoSuchBucketExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new NoSuchBucketException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_NoSuchConfigRuleExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new NoSuchConfigRuleException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_NoSuchConfigRuleInConformancePackExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new NoSuchConfigRuleInConformancePackException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_NoSuchConfigurationAggregatorExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new NoSuchConfigurationAggregatorException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_NoSuchConfigurationRecorderExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new NoSuchConfigurationRecorderException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_NoSuchConformancePackExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new NoSuchConformancePackException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_NoSuchDeliveryChannelExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new NoSuchDeliveryChannelException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_NoSuchOrganizationConfigRuleExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new NoSuchOrganizationConfigRuleException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_NoSuchOrganizationConformancePackExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new NoSuchOrganizationConformancePackException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_NoSuchRemediationConfigurationExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new NoSuchRemediationConfigurationException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_NoSuchRemediationExceptionExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new NoSuchRemediationExceptionException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_NoSuchRetentionConfigurationExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new NoSuchRetentionConfigurationException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_OrganizationAccessDeniedExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new OrganizationAccessDeniedException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_OrganizationAllFeaturesNotEnabledExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new OrganizationAllFeaturesNotEnabledException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_OrganizationConformancePackTemplateValidationExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new OrganizationConformancePackTemplateValidationException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_OversizedConfigurationItemExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new OversizedConfigurationItemException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_RemediationInProgressExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new RemediationInProgressException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_ResourceConcurrentModificationExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new ResourceConcurrentModificationException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_ResourceInUseExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new ResourceInUseException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_ResourceNotDiscoveredExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new ResourceNotDiscoveredException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_ResourceNotFoundExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new ResourceNotFoundException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_TooManyTagsExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new TooManyTagsException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const de_ValidationExceptionRes = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = _json(body);
    const exception = new ValidationException({
        $metadata: deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return __decorateServiceException(exception, body);
};
const se_Evaluation = (input, context) => {
    return take(input, {
        Annotation: [],
        ComplianceResourceId: [],
        ComplianceResourceType: [],
        ComplianceType: [],
        OrderingTimestamp: (_) => _.getTime() / 1000,
    });
};
const se_Evaluations = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return se_Evaluation(entry, context);
    });
};
const se_ExternalEvaluation = (input, context) => {
    return take(input, {
        Annotation: [],
        ComplianceResourceId: [],
        ComplianceResourceType: [],
        ComplianceType: [],
        OrderingTimestamp: (_) => _.getTime() / 1000,
    });
};
const se_GetResourceConfigHistoryRequest = (input, context) => {
    return take(input, {
        chronologicalOrder: [],
        earlierTime: (_) => _.getTime() / 1000,
        laterTime: (_) => _.getTime() / 1000,
        limit: [],
        nextToken: [],
        resourceId: [],
        resourceType: [],
    });
};
const se_ListResourceEvaluationsRequest = (input, context) => {
    return take(input, {
        Filters: (_) => se_ResourceEvaluationFilters(_, context),
        Limit: [],
        NextToken: [],
    });
};
const se_PutEvaluationsRequest = (input, context) => {
    return take(input, {
        Evaluations: (_) => se_Evaluations(_, context),
        ResultToken: [],
        TestMode: [],
    });
};
const se_PutExternalEvaluationRequest = (input, context) => {
    return take(input, {
        ConfigRuleName: [],
        ExternalEvaluation: (_) => se_ExternalEvaluation(_, context),
    });
};
const se_PutRemediationExceptionsRequest = (input, context) => {
    return take(input, {
        ConfigRuleName: [],
        ExpirationTime: (_) => _.getTime() / 1000,
        Message: [],
        ResourceKeys: _json,
    });
};
const se_ResourceEvaluationFilters = (input, context) => {
    return take(input, {
        EvaluationContextIdentifier: [],
        EvaluationMode: [],
        TimeWindow: (_) => se_TimeWindow(_, context),
    });
};
const se_TimeWindow = (input, context) => {
    return take(input, {
        EndTime: (_) => _.getTime() / 1000,
        StartTime: (_) => _.getTime() / 1000,
    });
};
const de_AggregateComplianceCount = (output, context) => {
    return take(output, {
        ComplianceSummary: (_) => de_ComplianceSummary(_, context),
        GroupName: __expectString,
    });
};
const de_AggregateComplianceCountList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_AggregateComplianceCount(entry, context);
    });
    return retVal;
};
const de_AggregatedSourceStatus = (output, context) => {
    return take(output, {
        AwsRegion: __expectString,
        LastErrorCode: __expectString,
        LastErrorMessage: __expectString,
        LastUpdateStatus: __expectString,
        LastUpdateTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        SourceId: __expectString,
        SourceType: __expectString,
    });
};
const de_AggregatedSourceStatusList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_AggregatedSourceStatus(entry, context);
    });
    return retVal;
};
const de_AggregateEvaluationResult = (output, context) => {
    return take(output, {
        AccountId: __expectString,
        Annotation: __expectString,
        AwsRegion: __expectString,
        ComplianceType: __expectString,
        ConfigRuleInvokedTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        EvaluationResultIdentifier: (_) => de_EvaluationResultIdentifier(_, context),
        ResultRecordedTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
    });
};
const de_AggregateEvaluationResultList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_AggregateEvaluationResult(entry, context);
    });
    return retVal;
};
const de_AggregationAuthorization = (output, context) => {
    return take(output, {
        AggregationAuthorizationArn: __expectString,
        AuthorizedAccountId: __expectString,
        AuthorizedAwsRegion: __expectString,
        CreationTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
    });
};
const de_AggregationAuthorizationList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_AggregationAuthorization(entry, context);
    });
    return retVal;
};
const de_BaseConfigurationItem = (output, context) => {
    return take(output, {
        accountId: __expectString,
        arn: __expectString,
        availabilityZone: __expectString,
        awsRegion: __expectString,
        configuration: __expectString,
        configurationItemCaptureTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        configurationItemDeliveryTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        configurationItemStatus: __expectString,
        configurationStateId: __expectString,
        recordingFrequency: __expectString,
        resourceCreationTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        resourceId: __expectString,
        resourceName: __expectString,
        resourceType: __expectString,
        supplementaryConfiguration: _json,
        version: __expectString,
    });
};
const de_BaseConfigurationItems = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_BaseConfigurationItem(entry, context);
    });
    return retVal;
};
const de_BatchGetAggregateResourceConfigResponse = (output, context) => {
    return take(output, {
        BaseConfigurationItems: (_) => de_BaseConfigurationItems(_, context),
        UnprocessedResourceIdentifiers: _json,
    });
};
const de_BatchGetResourceConfigResponse = (output, context) => {
    return take(output, {
        baseConfigurationItems: (_) => de_BaseConfigurationItems(_, context),
        unprocessedResourceKeys: _json,
    });
};
const de_ComplianceSummariesByResourceType = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_ComplianceSummaryByResourceType(entry, context);
    });
    return retVal;
};
const de_ComplianceSummary = (output, context) => {
    return take(output, {
        ComplianceSummaryTimestamp: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        CompliantResourceCount: _json,
        NonCompliantResourceCount: _json,
    });
};
const de_ComplianceSummaryByResourceType = (output, context) => {
    return take(output, {
        ComplianceSummary: (_) => de_ComplianceSummary(_, context),
        ResourceType: __expectString,
    });
};
const de_ConfigExportDeliveryInfo = (output, context) => {
    return take(output, {
        lastAttemptTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        lastErrorCode: __expectString,
        lastErrorMessage: __expectString,
        lastStatus: __expectString,
        lastSuccessfulTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        nextDeliveryTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
    });
};
const de_ConfigRuleEvaluationStatus = (output, context) => {
    return take(output, {
        ConfigRuleArn: __expectString,
        ConfigRuleId: __expectString,
        ConfigRuleName: __expectString,
        FirstActivatedTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        FirstEvaluationStarted: __expectBoolean,
        LastDeactivatedTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        LastDebugLogDeliveryStatus: __expectString,
        LastDebugLogDeliveryStatusReason: __expectString,
        LastDebugLogDeliveryTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        LastErrorCode: __expectString,
        LastErrorMessage: __expectString,
        LastFailedEvaluationTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        LastFailedInvocationTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        LastSuccessfulEvaluationTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        LastSuccessfulInvocationTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
    });
};
const de_ConfigRuleEvaluationStatusList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_ConfigRuleEvaluationStatus(entry, context);
    });
    return retVal;
};
const de_ConfigStreamDeliveryInfo = (output, context) => {
    return take(output, {
        lastErrorCode: __expectString,
        lastErrorMessage: __expectString,
        lastStatus: __expectString,
        lastStatusChangeTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
    });
};
const de_ConfigurationAggregator = (output, context) => {
    return take(output, {
        AccountAggregationSources: _json,
        ConfigurationAggregatorArn: __expectString,
        ConfigurationAggregatorName: __expectString,
        CreatedBy: __expectString,
        CreationTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        LastUpdatedTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        OrganizationAggregationSource: _json,
    });
};
const de_ConfigurationAggregatorList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_ConfigurationAggregator(entry, context);
    });
    return retVal;
};
const de_ConfigurationItem = (output, context) => {
    return take(output, {
        accountId: __expectString,
        arn: __expectString,
        availabilityZone: __expectString,
        awsRegion: __expectString,
        configuration: __expectString,
        configurationItemCaptureTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        configurationItemDeliveryTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        configurationItemMD5Hash: __expectString,
        configurationItemStatus: __expectString,
        configurationStateId: __expectString,
        recordingFrequency: __expectString,
        relatedEvents: _json,
        relationships: _json,
        resourceCreationTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        resourceId: __expectString,
        resourceName: __expectString,
        resourceType: __expectString,
        supplementaryConfiguration: _json,
        tags: _json,
        version: __expectString,
    });
};
const de_ConfigurationItemList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_ConfigurationItem(entry, context);
    });
    return retVal;
};
const de_ConfigurationRecorderStatus = (output, context) => {
    return take(output, {
        lastErrorCode: __expectString,
        lastErrorMessage: __expectString,
        lastStartTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        lastStatus: __expectString,
        lastStatusChangeTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        lastStopTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        name: __expectString,
        recording: __expectBoolean,
    });
};
const de_ConfigurationRecorderStatusList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_ConfigurationRecorderStatus(entry, context);
    });
    return retVal;
};
const de_ConformancePackComplianceScore = (output, context) => {
    return take(output, {
        ConformancePackName: __expectString,
        LastUpdatedTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        Score: __expectString,
    });
};
const de_ConformancePackComplianceScores = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_ConformancePackComplianceScore(entry, context);
    });
    return retVal;
};
const de_ConformancePackDetail = (output, context) => {
    return take(output, {
        ConformancePackArn: __expectString,
        ConformancePackId: __expectString,
        ConformancePackInputParameters: _json,
        ConformancePackName: __expectString,
        CreatedBy: __expectString,
        DeliveryS3Bucket: __expectString,
        DeliveryS3KeyPrefix: __expectString,
        LastUpdateRequestedTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        TemplateSSMDocumentDetails: _json,
    });
};
const de_ConformancePackDetailList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_ConformancePackDetail(entry, context);
    });
    return retVal;
};
const de_ConformancePackEvaluationResult = (output, context) => {
    return take(output, {
        Annotation: __expectString,
        ComplianceType: __expectString,
        ConfigRuleInvokedTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        EvaluationResultIdentifier: (_) => de_EvaluationResultIdentifier(_, context),
        ResultRecordedTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
    });
};
const de_ConformancePackRuleEvaluationResultsList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_ConformancePackEvaluationResult(entry, context);
    });
    return retVal;
};
const de_ConformancePackStatusDetail = (output, context) => {
    return take(output, {
        ConformancePackArn: __expectString,
        ConformancePackId: __expectString,
        ConformancePackName: __expectString,
        ConformancePackState: __expectString,
        ConformancePackStatusReason: __expectString,
        LastUpdateCompletedTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        LastUpdateRequestedTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        StackArn: __expectString,
    });
};
const de_ConformancePackStatusDetailsList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_ConformancePackStatusDetail(entry, context);
    });
    return retVal;
};
const de_DeliveryChannelStatus = (output, context) => {
    return take(output, {
        configHistoryDeliveryInfo: (_) => de_ConfigExportDeliveryInfo(_, context),
        configSnapshotDeliveryInfo: (_) => de_ConfigExportDeliveryInfo(_, context),
        configStreamDeliveryInfo: (_) => de_ConfigStreamDeliveryInfo(_, context),
        name: __expectString,
    });
};
const de_DeliveryChannelStatusList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_DeliveryChannelStatus(entry, context);
    });
    return retVal;
};
const de_DescribeAggregationAuthorizationsResponse = (output, context) => {
    return take(output, {
        AggregationAuthorizations: (_) => de_AggregationAuthorizationList(_, context),
        NextToken: __expectString,
    });
};
const de_DescribeConfigRuleEvaluationStatusResponse = (output, context) => {
    return take(output, {
        ConfigRulesEvaluationStatus: (_) => de_ConfigRuleEvaluationStatusList(_, context),
        NextToken: __expectString,
    });
};
const de_DescribeConfigurationAggregatorSourcesStatusResponse = (output, context) => {
    return take(output, {
        AggregatedSourceStatusList: (_) => de_AggregatedSourceStatusList(_, context),
        NextToken: __expectString,
    });
};
const de_DescribeConfigurationAggregatorsResponse = (output, context) => {
    return take(output, {
        ConfigurationAggregators: (_) => de_ConfigurationAggregatorList(_, context),
        NextToken: __expectString,
    });
};
const de_DescribeConfigurationRecorderStatusResponse = (output, context) => {
    return take(output, {
        ConfigurationRecordersStatus: (_) => de_ConfigurationRecorderStatusList(_, context),
    });
};
const de_DescribeConformancePacksResponse = (output, context) => {
    return take(output, {
        ConformancePackDetails: (_) => de_ConformancePackDetailList(_, context),
        NextToken: __expectString,
    });
};
const de_DescribeConformancePackStatusResponse = (output, context) => {
    return take(output, {
        ConformancePackStatusDetails: (_) => de_ConformancePackStatusDetailsList(_, context),
        NextToken: __expectString,
    });
};
const de_DescribeDeliveryChannelStatusResponse = (output, context) => {
    return take(output, {
        DeliveryChannelsStatus: (_) => de_DeliveryChannelStatusList(_, context),
    });
};
const de_DescribeOrganizationConfigRulesResponse = (output, context) => {
    return take(output, {
        NextToken: __expectString,
        OrganizationConfigRules: (_) => de_OrganizationConfigRules(_, context),
    });
};
const de_DescribeOrganizationConfigRuleStatusesResponse = (output, context) => {
    return take(output, {
        NextToken: __expectString,
        OrganizationConfigRuleStatuses: (_) => de_OrganizationConfigRuleStatuses(_, context),
    });
};
const de_DescribeOrganizationConformancePacksResponse = (output, context) => {
    return take(output, {
        NextToken: __expectString,
        OrganizationConformancePacks: (_) => de_OrganizationConformancePacks(_, context),
    });
};
const de_DescribeOrganizationConformancePackStatusesResponse = (output, context) => {
    return take(output, {
        NextToken: __expectString,
        OrganizationConformancePackStatuses: (_) => de_OrganizationConformancePackStatuses(_, context),
    });
};
const de_DescribeRemediationExceptionsResponse = (output, context) => {
    return take(output, {
        NextToken: __expectString,
        RemediationExceptions: (_) => de_RemediationExceptions(_, context),
    });
};
const de_DescribeRemediationExecutionStatusResponse = (output, context) => {
    return take(output, {
        NextToken: __expectString,
        RemediationExecutionStatuses: (_) => de_RemediationExecutionStatuses(_, context),
    });
};
const de_Evaluation = (output, context) => {
    return take(output, {
        Annotation: __expectString,
        ComplianceResourceId: __expectString,
        ComplianceResourceType: __expectString,
        ComplianceType: __expectString,
        OrderingTimestamp: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
    });
};
const de_EvaluationResult = (output, context) => {
    return take(output, {
        Annotation: __expectString,
        ComplianceType: __expectString,
        ConfigRuleInvokedTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        EvaluationResultIdentifier: (_) => de_EvaluationResultIdentifier(_, context),
        ResultRecordedTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        ResultToken: __expectString,
    });
};
const de_EvaluationResultIdentifier = (output, context) => {
    return take(output, {
        EvaluationResultQualifier: _json,
        OrderingTimestamp: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        ResourceEvaluationId: __expectString,
    });
};
const de_EvaluationResults = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_EvaluationResult(entry, context);
    });
    return retVal;
};
const de_Evaluations = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_Evaluation(entry, context);
    });
    return retVal;
};
const de_FailedRemediationExceptionBatch = (output, context) => {
    return take(output, {
        FailedItems: (_) => de_RemediationExceptions(_, context),
        FailureMessage: __expectString,
    });
};
const de_FailedRemediationExceptionBatches = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_FailedRemediationExceptionBatch(entry, context);
    });
    return retVal;
};
const de_GetAggregateComplianceDetailsByConfigRuleResponse = (output, context) => {
    return take(output, {
        AggregateEvaluationResults: (_) => de_AggregateEvaluationResultList(_, context),
        NextToken: __expectString,
    });
};
const de_GetAggregateConfigRuleComplianceSummaryResponse = (output, context) => {
    return take(output, {
        AggregateComplianceCounts: (_) => de_AggregateComplianceCountList(_, context),
        GroupByKey: __expectString,
        NextToken: __expectString,
    });
};
const de_GetAggregateResourceConfigResponse = (output, context) => {
    return take(output, {
        ConfigurationItem: (_) => de_ConfigurationItem(_, context),
    });
};
const de_GetComplianceDetailsByConfigRuleResponse = (output, context) => {
    return take(output, {
        EvaluationResults: (_) => de_EvaluationResults(_, context),
        NextToken: __expectString,
    });
};
const de_GetComplianceDetailsByResourceResponse = (output, context) => {
    return take(output, {
        EvaluationResults: (_) => de_EvaluationResults(_, context),
        NextToken: __expectString,
    });
};
const de_GetComplianceSummaryByConfigRuleResponse = (output, context) => {
    return take(output, {
        ComplianceSummary: (_) => de_ComplianceSummary(_, context),
    });
};
const de_GetComplianceSummaryByResourceTypeResponse = (output, context) => {
    return take(output, {
        ComplianceSummariesByResourceType: (_) => de_ComplianceSummariesByResourceType(_, context),
    });
};
const de_GetConformancePackComplianceDetailsResponse = (output, context) => {
    return take(output, {
        ConformancePackName: __expectString,
        ConformancePackRuleEvaluationResults: (_) => de_ConformancePackRuleEvaluationResultsList(_, context),
        NextToken: __expectString,
    });
};
const de_GetOrganizationConfigRuleDetailedStatusResponse = (output, context) => {
    return take(output, {
        NextToken: __expectString,
        OrganizationConfigRuleDetailedStatus: (_) => de_OrganizationConfigRuleDetailedStatus(_, context),
    });
};
const de_GetOrganizationConformancePackDetailedStatusResponse = (output, context) => {
    return take(output, {
        NextToken: __expectString,
        OrganizationConformancePackDetailedStatuses: (_) => de_OrganizationConformancePackDetailedStatuses(_, context),
    });
};
const de_GetResourceConfigHistoryResponse = (output, context) => {
    return take(output, {
        configurationItems: (_) => de_ConfigurationItemList(_, context),
        nextToken: __expectString,
    });
};
const de_GetResourceEvaluationSummaryResponse = (output, context) => {
    return take(output, {
        Compliance: __expectString,
        EvaluationContext: _json,
        EvaluationMode: __expectString,
        EvaluationStartTimestamp: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        EvaluationStatus: _json,
        ResourceDetails: _json,
        ResourceEvaluationId: __expectString,
    });
};
const de_ListConformancePackComplianceScoresResponse = (output, context) => {
    return take(output, {
        ConformancePackComplianceScores: (_) => de_ConformancePackComplianceScores(_, context),
        NextToken: __expectString,
    });
};
const de_ListDiscoveredResourcesResponse = (output, context) => {
    return take(output, {
        nextToken: __expectString,
        resourceIdentifiers: (_) => de_ResourceIdentifierList(_, context),
    });
};
const de_ListResourceEvaluationsResponse = (output, context) => {
    return take(output, {
        NextToken: __expectString,
        ResourceEvaluations: (_) => de_ResourceEvaluations(_, context),
    });
};
const de_MemberAccountStatus = (output, context) => {
    return take(output, {
        AccountId: __expectString,
        ConfigRuleName: __expectString,
        ErrorCode: __expectString,
        ErrorMessage: __expectString,
        LastUpdateTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        MemberAccountRuleStatus: __expectString,
    });
};
const de_OrganizationConfigRule = (output, context) => {
    return take(output, {
        ExcludedAccounts: _json,
        LastUpdateTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        OrganizationConfigRuleArn: __expectString,
        OrganizationConfigRuleName: __expectString,
        OrganizationCustomPolicyRuleMetadata: _json,
        OrganizationCustomRuleMetadata: _json,
        OrganizationManagedRuleMetadata: _json,
    });
};
const de_OrganizationConfigRuleDetailedStatus = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_MemberAccountStatus(entry, context);
    });
    return retVal;
};
const de_OrganizationConfigRules = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_OrganizationConfigRule(entry, context);
    });
    return retVal;
};
const de_OrganizationConfigRuleStatus = (output, context) => {
    return take(output, {
        ErrorCode: __expectString,
        ErrorMessage: __expectString,
        LastUpdateTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        OrganizationConfigRuleName: __expectString,
        OrganizationRuleStatus: __expectString,
    });
};
const de_OrganizationConfigRuleStatuses = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_OrganizationConfigRuleStatus(entry, context);
    });
    return retVal;
};
const de_OrganizationConformancePack = (output, context) => {
    return take(output, {
        ConformancePackInputParameters: _json,
        DeliveryS3Bucket: __expectString,
        DeliveryS3KeyPrefix: __expectString,
        ExcludedAccounts: _json,
        LastUpdateTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        OrganizationConformancePackArn: __expectString,
        OrganizationConformancePackName: __expectString,
    });
};
const de_OrganizationConformancePackDetailedStatus = (output, context) => {
    return take(output, {
        AccountId: __expectString,
        ConformancePackName: __expectString,
        ErrorCode: __expectString,
        ErrorMessage: __expectString,
        LastUpdateTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        Status: __expectString,
    });
};
const de_OrganizationConformancePackDetailedStatuses = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_OrganizationConformancePackDetailedStatus(entry, context);
    });
    return retVal;
};
const de_OrganizationConformancePacks = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_OrganizationConformancePack(entry, context);
    });
    return retVal;
};
const de_OrganizationConformancePackStatus = (output, context) => {
    return take(output, {
        ErrorCode: __expectString,
        ErrorMessage: __expectString,
        LastUpdateTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        OrganizationConformancePackName: __expectString,
        Status: __expectString,
    });
};
const de_OrganizationConformancePackStatuses = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_OrganizationConformancePackStatus(entry, context);
    });
    return retVal;
};
const de_PutAggregationAuthorizationResponse = (output, context) => {
    return take(output, {
        AggregationAuthorization: (_) => de_AggregationAuthorization(_, context),
    });
};
const de_PutConfigurationAggregatorResponse = (output, context) => {
    return take(output, {
        ConfigurationAggregator: (_) => de_ConfigurationAggregator(_, context),
    });
};
const de_PutEvaluationsResponse = (output, context) => {
    return take(output, {
        FailedEvaluations: (_) => de_Evaluations(_, context),
    });
};
const de_PutRemediationExceptionsResponse = (output, context) => {
    return take(output, {
        FailedBatches: (_) => de_FailedRemediationExceptionBatches(_, context),
    });
};
const de_RemediationException = (output, context) => {
    return take(output, {
        ConfigRuleName: __expectString,
        ExpirationTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        Message: __expectString,
        ResourceId: __expectString,
        ResourceType: __expectString,
    });
};
const de_RemediationExceptions = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_RemediationException(entry, context);
    });
    return retVal;
};
const de_RemediationExecutionStatus = (output, context) => {
    return take(output, {
        InvocationTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        LastUpdatedTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        ResourceKey: _json,
        State: __expectString,
        StepDetails: (_) => de_RemediationExecutionSteps(_, context),
    });
};
const de_RemediationExecutionStatuses = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_RemediationExecutionStatus(entry, context);
    });
    return retVal;
};
const de_RemediationExecutionStep = (output, context) => {
    return take(output, {
        ErrorMessage: __expectString,
        Name: __expectString,
        StartTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        State: __expectString,
        StopTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
    });
};
const de_RemediationExecutionSteps = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_RemediationExecutionStep(entry, context);
    });
    return retVal;
};
const de_ResourceEvaluation = (output, context) => {
    return take(output, {
        EvaluationMode: __expectString,
        EvaluationStartTimestamp: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        ResourceEvaluationId: __expectString,
    });
};
const de_ResourceEvaluations = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_ResourceEvaluation(entry, context);
    });
    return retVal;
};
const de_ResourceIdentifier = (output, context) => {
    return take(output, {
        resourceDeletionTime: (_) => __expectNonNull(__parseEpochTimestamp(__expectNumber(_))),
        resourceId: __expectString,
        resourceName: __expectString,
        resourceType: __expectString,
    });
};
const de_ResourceIdentifierList = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        return de_ResourceIdentifier(entry, context);
    });
    return retVal;
};
const deserializeMetadata = (output) => ({
    httpStatusCode: output.statusCode,
    requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"],
});
const collectBodyString = (streamBody, context) => collectBody(streamBody, context).then((body) => context.utf8Encoder(body));
const throwDefaultError = withBaseException(__BaseException);
const buildHttpRpcRequest = async (context, headers, path, resolvedHostname, body) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const contents = {
        protocol,
        hostname,
        port,
        method: "POST",
        path: basePath.endsWith("/") ? basePath.slice(0, -1) + path : basePath + path,
        headers,
    };
    if (resolvedHostname !== undefined) {
        contents.hostname = resolvedHostname;
    }
    if (body !== undefined) {
        contents.body = body;
    }
    return new __HttpRequest(contents);
};
function sharedHeaders(operation) {
    return {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": `StarlingDoveService.${operation}`,
    };
}
